import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twentythree-twentyfour',
  templateUrl: './twentythree-twentyfour.component.html',
  styleUrls: ['./twentythree-twentyfour.component.scss']
})
export class TwentythreeTwentyfourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
